import { useTranslation } from "react-i18next";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { RAGStatus } from "../shared/enums/Result";
import clsx from "clsx";

interface Props {
  ragStatus: RAGStatus;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: "2px",
      padding: theme.spacing(0.5, 1),
      textTransform: "uppercase",
      fontWeight: 700,
      fontSize: "0.75em",
      letterSpacing: ".3px",
    },
    Red: {
      backgroundColor: theme.palette.redStatus.main,
      color: theme.palette.redStatus.contrastText,
    },
    Amber: {
      backgroundColor: theme.palette.amberStatus.main,
      color: theme.palette.amberStatus.contrastText,
    },
    Green: {
      backgroundColor: theme.palette.greenStatus.main,
      color: theme.palette.greenStatus.contrastText,
    },
    None: {
      backgroundColor: theme.palette.lightBackground.main,
      color: theme.palette.lightBackground.contrastText,
    },
  }),
);

export default function RAGStatusChip(props: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  return <span className={clsx(classes.root, classes[props.ragStatus])}>{t(`ragStatus.${props.ragStatus}`)}</span>;
}
